import { addNamespace } from './utils'

/**
 * @file
 * @author Thomas Grinderslev <thomas@edulab.dk>
 */

/**
 * @typedef {{userClass: number, userType: UserType}} AuthStoreState
 */

/**
 * The types used in this store
 * @enum {string}
 */
export const AuthStoreTypes = {
  getters: {
    GET_USER_CLASS: 'getUserClass',
    GET_USER_TYPE: 'getUserType',
  },
  actions: {
    SET_USER_CLASS: 'setUserClass',
    SET_USER_TYPE: 'setUserType',
  },
  mutations: {
    SET_USER_CLASS: 'setUserClass',
    SET_USER_TYPE: 'setUserType',
  },
}

/**
 * A namespaced version of the types used in this store
 * @enum {string}
 */
export const AuthStoreNamespacedTypes = addNamespace('auth', AuthStoreTypes)

export function state() {
  return { userClass: null, userType: null }
}

export const getters = {
  /**
   * @param {AuthStoreState} state
   * @return {function(): number|null}
   */
  [AuthStoreTypes.getters.GET_USER_CLASS]: state => () => {
    return state.userClass
  },

  /**
   * @param {AuthStoreState} state
   * @return {function(): UserType|null}
   */
  [AuthStoreTypes.getters.GET_USER_TYPE]: state => () => {
    return state.userType
  },
}

export const actions = {
  /**
   * @param {VuexCommit} commit
   * @param {number} userClass
   */
  [AuthStoreTypes.actions.SET_USER_CLASS]({ commit }, userClass) {
    commit(AuthStoreTypes.mutations.SET_USER_CLASS, userClass)
  },

  /**
   * @param {VuexCommit} commit
   * @param {UserType} userType
   */
  [AuthStoreTypes.actions.SET_USER_TYPE]({ commit }, userType) {
    commit(AuthStoreTypes.mutations.SET_USER_TYPE, userType)
  },
}

export const mutations = {
  /**
   * @param {AuthStoreState} state
   * @param {number} userClass
   */
  [AuthStoreTypes.mutations.SET_USER_CLASS](state, userClass) {
    state.userClass = userClass
  },

  /**
   * @param {AuthStoreState} state
   * @param {UserType} userType
   */
  [AuthStoreTypes.mutations.SET_USER_TYPE](state, userType) {
    state.userType = userType
  },
}

export default {
  namespaced: true,
  Types: AuthStoreTypes,
  NamespacedTypes: AuthStoreNamespacedTypes,
  state,
  getters,
  actions,
  mutations,
}
